import * as React from 'react'
import { IMaskInput } from 'react-imask'
import Box from '@mui/material/Box'
import Input from '@mui/material/Input'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void
    name: string
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props
        return (
            <IMaskInput
                {...other}
                mask="0000 00 000"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={(ref as any)}
                onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        )
    },
)

type MobileNumberTextFieldType = {
    value: string,
    setValue: (value: string) => void,
    hasError: boolean,
    disabled: boolean,
    hasTitle?: boolean | null
}

const MobileNumberTextField = (props: MobileNumberTextFieldType) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.setValue(event.target.value)
    }

    return (

        <FormControl variant="outlined">
            <TextField
                variant="standard"
                label={props.hasTitle == null ? "Телефонен номер" : ""}
                InputProps={{
                    inputComponent: TextMaskCustom as any,
                    startAdornment: <InputAdornment position="start">+359</InputAdornment>,
                    // disableUnderline: true,
                }}
                disabled={props.disabled}
                error={props.hasError}
                value={props.value}
                onChange={handleChange}
                name="textmask"
                size="small"
                id="mobileNumber" />
        </FormControl>
    )
}

export default MobileNumberTextField